import React, { useState, useEffect } from "react";

const UserModal = ({
  isOpen,
  onClose,
  onSave,
  mode = "add",          // "add" | "edit"
  initialData = {},      // {id, username, first_name, last_name, role, hospital_id}
  hospitals = [],
  showHospitalSelect = true,
  isDemoRegistration = false,
  isAdminRegistration = false,
  error = null,
}) => {
  const [form, setForm] = useState({
    username: "",
    password: "",
    first_name: "",
    last_name: "",
    role: isDemoRegistration ? "demo" : "admin",
    hospital_id: "",
    enabled: isAdminRegistration ? true : false,   // ✅ pre-select
  });

  const [formError, setFormError] = useState(""); // 👈 local error state
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ reset state when modal opens
//  useEffect(() => {
//    if (isOpen) {
//      setForm({
//        username: initialData.username || "",
//        password: "",
//        first_name: initialData.first_name || "",
//        last_name: initialData.last_name || "",
//        role: isDemoRegistration ? "demo" : isAdminRegistration ? "doctor" : initialData.role || "user",
//        hospital_id: initialData.hospital_id || "",
//        enabled: isAdminRegistration ? true : initialData.enabled ?? undefined,
//      });
//      setFormError(""); // reset errors
//    }
//  }, [isOpen, initialData?.id, isDemoRegistration, isAdminRegistration]);

useEffect(() => {
  if (isOpen) {
    setForm({
      username: initialData.username || "",
      password: "",
      first_name: initialData.first_name || "",
      last_name: initialData.last_name || "",
      role:
        mode === "edit"
          ? initialData.role
          : isDemoRegistration
          ? "demo"
          : isAdminRegistration
          ? "doctor"
          : "user",
      hospital_id: Array.isArray(initialData.hospitals)
        ? initialData.hospitals.map((h) => h.id)
        : [],   // ✅ always array
      enabled: initialData.enabled === 1 || initialData.enabled === true, // ✅ exact
    });
    setFormError(""); // reset errors
  }
}, [isOpen, initialData?.id, isDemoRegistration, isAdminRegistration, mode]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setIsSubmitting(true);

    const payload = { ...form, id: initialData.id };

    //if (!showHospitalSelect) {
    //  delete payload.hospital_id;
    //}

    if (isDemoRegistration) {
      payload.role = "demo";
      payload.enabled = true;
      delete payload.hospital_id;
    }
      
    if (isAdminRegistration || form.role === "doctor") {
      payload.role = "doctor";
      payload.enabled = form.enabled ?? true;
      payload.hospital_ids = Array.isArray(form.hospital_id)
        ? form.hospital_id
        : form.hospital_id
        ? [form.hospital_id]
        : [];
    }

    try {
      await onSave(payload); // parent handles API call
    } catch (err) {
      setFormError(err.message || "Failed to save user");
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(false);
  };
  
//  ////////////
//  if (mode === "edit") {
//    payload.enabled = form.enabled;
//    // username, role locked → don’t modify
//  }
//  if (form.role === "demo") {
//    delete payload.hospital_id; // no hospital for demo
//  }
//  if (form.role === "doctor") {
//    // make sure hospital_id is array
//    payload.hospital_id = Array.isArray(form.hospital_id) ? form.hospital_id : [];
//  }

  ///////////

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 animate-fadeIn">
        <h2 className="text-2xl font-bold text-cyan-700 mb-6">
          {mode === "edit" ? "Edit User" : isDemoRegistration ? "Register Demo User" : "Add User"}
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username */}
          <div>
            <label className="block text-sm font-medium mb-1">Username</label>
            <input
              name="username"
              value={form.username}
              onChange={handleChange}
              placeholder="Enter username"
              disabled={mode === "edit"}
              className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
              required
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium mb-1">Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder={mode === "edit" ? "New password (optional)" : "Enter password"}
              className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
              required={mode === "add"}
            />
          </div>

          {/* First + Last name */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">First Name</label>
              <input
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                placeholder="First name"
                className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Last Name</label>
              <input
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
                placeholder="Last name"
                className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
                required
              />
            </div>
          </div>

{/* Hospital selection */}
{!(isDemoRegistration || form.role === "demo") && hospitals.length > 0 && (
  <div>
    <label className="block text-sm font-medium mb-1">Hospitals</label>
    <div className="border rounded-md p-2 max-h-32 overflow-y-auto">
      <div className="grid grid-cols-1 gap-2">
        {hospitals.map((h) => (
          <label key={h.id} className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hospital_id"
              value={h.id}
              checked={Array.isArray(form.hospital_id) && form.hospital_id.includes(h.id)}
              onChange={(e) => {
                const checked = e.target.checked;
                setForm((prev) => {
                  const current = Array.isArray(prev.hospital_id) ? prev.hospital_id : [];
                  return {
                    ...prev,
                    hospital_id: checked
                      ? [...current, h.id]
                      : current.filter((id) => id !== h.id),
                  };
                });
              }}
              className="h-4 w-4 text-cyan-600 border-gray-300 rounded"
            />
            {h.name}
          </label>
        ))}
      </div>
    </div>
  </div>
)}


          
          {/* Only for admin registration → Enabled checkbox */}
	  {(isAdminRegistration || mode === "edit") && (
	    <div className="flex items-center gap-2">
	      <input
	        type="checkbox"
	        name="enabled"
	        checked={form.enabled}
	        onChange={handleChange}
	        className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300 rounded"
	      />
	      <label className="text-sm font-medium">Enabled</label>
	    </div>
          )}

          {/* Error */}
          {formError && (
            <div className="text-red-600 text-sm mt-2">{formError}</div>
          )}

          {/* Actions */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-lg bg-cyan-700 text-white hover:bg-cyan-800 disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : mode === "edit" ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserModal;
